import React, { useEffect, useRef } from "react";
import { Reveal, Kicker, Section } from "@/components/landing/kit";

const SCRIPT_SRC = "https://www.trustcaptain.io/widget/dsaecommerce.com.js";

const Reviews = () => {
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <Section id="reviews" className="border-y border-[#E5E8F0] bg-white py-24 sm:py-32">
      <Reveal className="mx-auto mb-14 max-w-3xl text-center">
        <Kicker className="mb-5 justify-center">Verified 5-star reviews</Kicker>
        <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
          Rated by the people who trust us with their stores.
        </h2>
      </Reveal>

      <Reveal delay={0.05} className="mx-auto max-w-5xl">
        <div className="rounded-3xl border border-[#E5E8F0] bg-white p-4 shadow-sm sm:p-8">
          <div
            id="trustcaptain-widget"
            data-domain="dsaecommerce.com"
            data-testid="trustcaptain-widget"
            style={{ width: "100%", maxWidth: "100%" }}
          />
        </div>
      </Reveal>
    </Section>
  );
};

export default Reviews;
